import { Tablet, Smartphone } from 'lucide-react'
import type { Viewport } from './types'

// Small banner shown inside the style / size editors when the user is
// editing a non-desktop breakpoint (driven by the toolbar DeviceToggle).
// Clarifies that the values being edited are overrides layered on top of
// the Desktop base, so an empty field means "inherit from a wider screen".
export default function BreakpointHint({ viewport }: { viewport: Viewport }) {
  if (viewport === 'desktop') return null
  const Icon = viewport === 'tablet' ? Tablet : Smartphone
  const label = viewport === 'tablet' ? 'Tablet' : 'Mobile'
  const inherits = viewport === 'tablet' ? 'Desktop' : 'Tablet / Desktop'
  return (
    <div
      style={{
        display: 'flex', alignItems: 'center', gap: 6,
        padding: '6px 8px',
        borderRadius: 6,
        background: 'var(--color-accent-weak)',
        border: '1px solid var(--color-accent)',
        color: 'var(--color-text)',
        fontSize: '0.8125rem',
        lineHeight: 1.35,
      }}
    >
      <Icon size={13} style={{ flexShrink: 0, color: 'var(--color-accent)' }} />
      <span>
        Editing <strong>{label}</strong> overrides. Empty fields inherit from {inherits}.
      </span>
    </div>
  )
}
